import React, { useEffect, useState } from "react";
import { FaEye } from "react-icons/fa";
import styles from "./DispatchTrayCard.module.css";
import SterilizationImg from "../../assets/images/ICONO STERILIZATION NEW.svg";
import WashingImg from "../../assets/images/WASHING.svg";
import { LuPackageCheck } from "react-icons/lu";
import df from "../../utils/dateFormater";
import Tooltip from "@material-ui/core/Tooltip";
import t from "../../utils/translation";

export default function DispatchPackageCard({
  pkg,
  selected,
  onClick = () => {},
  onDetailClick,
  release,
  releaseClick,
  observations,
  handleObservations,
  moveTo,
  storageColor,
}) {
  const [localObservation, setLocalObservation] = useState("");

const buttonClick = (e, id) => {
  e.stopPropagation();
  release && releaseClick(pkg, id);
};

const color = (id) =>
  id === 3 ? styles.green : styles.blue; // moveTo 1: azul, moveTo 3: verde

useEffect(() => {
  setLocalObservation("");
}, [pkg]);

let border = storageColor ? { borderLeft: `8px solid ${storageColor}` } : {};

return (
  <div
    className={`${styles.packageItem} ${color(moveTo)} ${
      selected ? styles.selected : ""
    }`}
    onClick={() => onClick(pkg.id)}
    style={border}
  >
    <div className={styles.container}>
      <div className={styles.packageHeader}>
        <span className={styles.packageNumber}>{pkg.packageNumber}</span>
      </div>
      <p className={styles.packageDescription}>{pkg.packageName}</p>
      {pkg.dateReleased && (
        <p className={styles.packageDescription}>
          <LuPackageCheck />
          {df(pkg.dateReleased, "dateTime")}
        </p>
      )}

      {release && (
        <>
          <div className={styles.buttonContainer}>
            <Tooltip title={t("BlankEntry142")} arrow>
              <div
                className={`${styles.button} ${color(1)} ${
                  moveTo === 1 ? styles.active : ""
                }`}
                onClick={(e) => buttonClick(e, 1)}
              >
                <img src={WashingImg} className={styles.icon} alt="Washing" />
              </div>
            </Tooltip>

            <Tooltip title={t("BlankEntry141")} arrow>
              <div
                className={`${styles.button} ${color(3)} ${
                  moveTo === 3 ? styles.active : ""
                }`}
                onClick={(e) => buttonClick(e, 3)}
              >
                <LuPackageCheck className={styles.icon} />
              </div>
            </Tooltip>
          </div>

          <textarea
            className={styles.observationInput}
            value={localObservation}
            placeholder={t("ObservationSpan")}
            onClick={(e) => e.stopPropagation()}
            onChange={(e) => {
              setLocalObservation(e.target.value);
              handleObservations(pkg.packageId, e.target.value);
            }}
            disabled={!selected}
          />
        </>
      )}
    </div>
  </div>
);
}
